import { ActionInformation } from './../../../../../Models/ActionInformation';
import { TranslateService } from '@ngx-translate/core';
import { Solution } from './../../../../../Models/Solution';
import { Component,Input, OnInit , OnDestroy } from '@angular/core';
import { SolutionService } from 'src/app/back-office/Services/solution.service';
import { Subscription } from 'rxjs';
import { Helper } from 'src/app/helpers/helper.service';

@Component({
  selector: 'app-solution-action-text',
  templateUrl: './solution-action-text.component.html',
  styleUrls: ['./solution-action-text.component.scss']
})
export class SolutionActionTextComponent implements OnInit, OnDestroy {

  @Input() Index: number;

  public modules = {};
  public contentBody;
  public solution: Solution = new Solution();
  private subscriptions: Subscription[] = [];
  public tokens = [];


  constructor(
    private solutionService: SolutionService,
    public helper: Helper,
    private translate: TranslateService
  ) {
    
    this.modules = {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        

        [{'header': 1}, {'header': 2}],               
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],          
        [{'direction': 'rtl'}],                        

        [{'size': ['small', false, 'large', 'huge']}],
        [{'header': [1, 2, 3, 4, 5, 6, false]}],

        [{'color': []}, {'background': []}],
        [{'align': []}],
        ['link']
      ]
    };

    this.tokens = [
      {description:'current_user' , name:'{{current_user.fullname}}'},
      {description:'order_number' , name:'{{order.orderNo}}'},
    ];

   }

  ngOnInit() {

    this.subscriptions.push(
      this.solutionService.solution.subscribe(solution => {
        this.solution = solution;
        if (this.solution.solutionSteps[this.Index] &&  !this.solution.solutionSteps[this.Index].actionInformation) {
          this.solution.solutionSteps[this.Index].actionInformation = new ActionInformation();
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public clipboardUpdated() {
    this.helper.showNotify('',
      this.translate.instant('admin.emails.manage.copied_to_clipboard'),
      'success'
    );
  }

  updateSolution() {
    this.solutionService.solution.next(this.solution);
  }

}
